import React from "react";

// Full-bleed section band. tone: "bone" | "spruce" | "ink"
export const Band = ({ tone = "bone", className = "", children, id, ...rest }) => {
  const tones = {
    bone: "bg-bone text-ink",
    spruce: "bg-spruce text-bone",
    ink: "bg-ink text-bone",
  };
  return (
    <section
      id={id}
      className={`band ${tones[tone]} py-20 sm:py-24 lg:py-28 ${className}`}
      {...rest}
    >
      <div className="band-inner">{children}</div>
    </section>
  );
};

export const Eyebrow = ({ children, tone = "spruce" }) => (
  <div
    className={`tabular text-xs tracking-[0.18em] uppercase mb-5 ${
      tone === "spruce" ? "text-sage" : "text-sage"
    }`}
  >
    {children}
  </div>
);

export default Band;
